import { Lock } from 'lucide-react';

interface PreviewVersionChipProps {
  versionName: string;
  createdAt: string | Date;
  onRestore: () => void;
  onExit: () => void;
}

export function PreviewVersionChip({
  versionName,
  createdAt,
  onRestore,
  onExit,
}: PreviewVersionChipProps) {
  const date = typeof createdAt === 'string' ? new Date(createdAt) : createdAt;
  return (
    <div className="flex items-center gap-1 bg-amber-50 border border-amber-200 rounded-md px-1 py-0.5">
      <Lock className="h-3 w-3 text-amber-600 ml-1.5" />
      <span className="text-amber-800 text-xs px-1.5">
        <span className="font-semibold">&ldquo;{versionName}&rdquo;</span>
        <span className="text-amber-600 ml-1.5">
          {date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
          })}
        </span>
      </span>
      <span className="text-amber-300">|</span>
      <button
        type="button"
        onClick={onRestore}
        className="text-xs font-medium text-amber-700 hover:text-amber-900 px-2 py-1 rounded hover:bg-amber-100"
      >
        Restore
      </button>
      <button
        type="button"
        onClick={onExit}
        className="text-xs font-medium text-gray-500 hover:text-gray-700 px-2 py-1 rounded hover:bg-gray-100"
      >
        Exit
      </button>
    </div>
  );
}
